// extracted by mini-css-extract-plugin
export default {"tasks":"jN-z","task":"kN-z","svg":"lN-z","text":"mN-z"};